import React, { useEffect } from 'react'
import CustomModal from '../../baseComponents/gui/customModal/CustomModal'
import { Scrollbar } from 'react-scrollbars-custom'
import { compilationScrollbarSettings } from '../../../constants/copyright'
import { safeHTML } from '../../../utils/safeHTML'
import Product from '../../features/product'
import CustomButton from '../../features/customButton/ui/main/CustomButton'
import { useModal } from '../../../hooks/useModal'
import Back from '../../features/back/Back'
import { useContent, useProducts } from '../../../redux/reducer/content'
import { useOpen } from '../../../hooks/useOpen'
import { useTranslation } from '../../../translations'
import useGetProductsAndClear from '../../features/product/model/hooks/useGetProductsAndClear'
import AppLoader from '../../features/appLoader/AppLoader'
import { gtmFunctions } from '../../../constants/analytics/GTM'

const SelectionModal = React.forwardRef(function ({ filter, title, text, button, callbacks }, ref) {
  const { closeModal, id } = useModal()
  const { beautyRoutine } = useContent()
  const { buyProducts, productsFromGA } = useProducts()
  const [getProducts, isPendingProducts] = useGetProductsAndClear()
  const openLink = useOpen()
  const { t } = useTranslation()
  const close = () => closeModal(id)

  const isBeautyRoutine = true

  const goToShop = () => {
    openLink(beautyRoutine.link)
    gtmFunctions.GTMBeautyRoutineShop()
  }

  useEffect(() => {
    const filterFunction =
      {
        procedure: ({ beauty_routine_id }) => beauty_routine_id === beautyRoutine?.id,
        unused: (product) =>
          !product.beauty_routine_id &&
          !product.beauty_procedure_id &&
          !product.quiz_quest_id &&
          !product.game_type,
      }[filter] ?? (() => true)
    getProducts(
      buyProducts.reduce((acc, product) => {
        filterFunction(product) && acc.push(product.sku)
        return acc
      }, []),
      isBeautyRoutine,
    )
  }, [])

  return (
    <CustomModal animation={['fade', 'scale', 'scale-bounce']}>
      <div
        className={'selection-modal'}
        ref={ref}
      >
        <div className='selection-modal__content'>
          <Scrollbar {...compilationScrollbarSettings}>
            <div className={'selection-modal__header'}>
              <Back
                onClick={close}
                className={'back_black'}
              />
              <div className={'selection-modal__title'}>{safeHTML(t(title))}</div>
            </div>
            {text && <div className={'selection-modal__text'}>{safeHTML(t(text))}</div>}
            <div className={'selection-modal__list'}>
              {productsFromGA?.map?.((item) => (
                <Product
                  key={item.id}
                  {...item}
                  className={'product_quiz product_quiz-gray'}
                  noCode={true}
                />
              ))}
            </div>
            {
              {
                procedure: (
                  <CustomButton
                    {...button.attr}
                    onClick={goToShop}
                  />
                ),
              }[filter]
            }
          </Scrollbar>
        </div>
        {isPendingProducts && <AppLoader />}
      </div>
    </CustomModal>
  )
})
export default SelectionModal
SelectionModal.propTypes = {}
